import { useState } from "react";
import { Download, FileText, Play, User } from "lucide-react"
import { recordingsData } from "@/data/recordingsData";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import MainSidebar from "@/shared/MainSidebar";

export default function ViewRecordings({ data = recordingsData }) {
    const [activeTab, setActiveTab] = useState("notes")

    return (
        <MainSidebar>
            <div className="max-w-4xl mx-auto w-fullsm:p-6 pt-0">
                {/* Page Header */}
                <div className="mb-2 pt-0">
                    <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2 font-heading">24A Python Programming Class</h1>
                    <p className="text-gray-600 font-body">Held on Thursday, Jun 14 . From 7.00pc to 9.00pm . By John Doe</p>
                </div>

                {/* Video Player */}
                <Card className="mb-2 rounded-xl border-none shadow-none">
                    <CardContent className="p-0">
                        <div
                            className="pt-0 h-100 w-full relative rounded-xl overflow-hidden flex items-center justify-start"
                            style={{
                                backgroundImage: `url(/src/assets/images/thumbnail.png)`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        >
                            <div className="absolute inset-0 bg-black/60" />
                            <div className="relative flex flex-col items-start justify-center h-full pl-6 sm:pl-12">
                                <div className="text-white text-4xl sm:text-6xl font-bold mb-4">MS FABRIC</div>
                                <div className="text-white text-4xl sm:text-6xl font-bold mb-4">DATA ANALYTICS</div>
                                <div className="bg-cream text-red text-2xl sm:text-4xl font-bold px-4 sm:px-6 py-2">
                                    TECH MASTERCLASS
                                </div>
                            </div>
                            <div className="absolute inset-0 flex items-center justify-center">
                                <Button
                                    className="w-14 h-14 bg-black/80 rounded-md flex items-center justify-center hover:bg-black/70 transition-colors border border-red"
                                >
                                    <Play size={40} className="text-red ml-1" />
                                </Button>
                            </div>
                        </div>
                    </CardContent>
                </Card>

                {/* Download Buttons */}
                <div className="flex flex-col sm:flex-row gap-2 mb-6 ">
                    <Button className="flex-1 bg-red text-white hover:bg-red-600 rounded-sm">
                        Download Recording
                        <Download className="w-5 h-5 mr-2" />
                    </Button>
                    <Button variant="outline" className="flex-1 border border-red rounded-sm text-red hover:bg-blue hover:text-white hover:border-none">
                        Download Transcript
                        <FileText className="w-5 h-5 mr-2" />
                    </Button>
                </div>

                {/* Tabs */}
                <Tabs defaultValue="notes" value={activeTab} onValueChange={setActiveTab} className="w-full">
                    <TabsList className="bg-cream p-1 rounded-lg flex gap-2 sm:gap-4">
                        <TabsTrigger
                            value="notes"
                            className="px-4 py-1 sm:px-6 sm:py-2 rounded-md
                            transition-all duration-300 ease-in-out font-medium font-body
                            data-[state=active]:bg-white
                            data-[state=active]:text-red
                            data-[state=active]:shadow-sm
                            hover:border-2
                            hover:text-red
                            hover:bg-white
                            text-gray-450
                            border-2 border-transparent">
                            Notes
                        </TabsTrigger>
                        <TabsTrigger
                            value="transcript"
                            className="px-4 py-1 sm:px-6 sm:py-2 rounded-md
                            transition-all duration-300 ease-in-out font-medium font-body
                            data-[state=active]:bg-white
                            data-[state=active]:text-red
                            data-[state=active]:shadow-sm
                            hover:border-2
                            hover:text-red
                            hover:bg-white
                            text-gray-450
                            border-2 border-transparent">
                            Transcript
                        </TabsTrigger>
                    </TabsList>

                    <TabsContent value="notes" className="space-y-6 w-full">
                        <div>
                            <h2 className="text-xl font-bold mb-4 font-heading">Notes from Meeting Chat</h2>
                            <div className="space-y-4">
                                {data.map((note) => (
                                    <div key={`note-${note.id}`} className="flex space-x-4 bg-gray-100 rounded-lg p-4">
                                        <Avatar>
                                            <AvatarImage src={note.avatar} alt={note.name} />
                                            <AvatarFallback>
                                                <User className="w-5 h-5" />
                                            </AvatarFallback>
                                        </Avatar>
                                        <div className="flex-1">
                                            <h3 className="font-medium text-gray-900 mb-1 font-heading">{note.name}</h3>
                                            <p className="text-gray-700 leading-relaxed font-body">{note.message}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </TabsContent>

                    <TabsContent value="transcript" className="space-y-6 w-full">
                        <div>
                            <h2 className="text-xl font-bold mb-4 font-heading">Auto Generated Video Transcript</h2>
                            <div className="space-y-4">
                                {data.map((transcript) => (
                                    <div key={`transcript-${transcript.id}`} className="flex-1 space-x-4">
                                        <p className="text-gray-400 min-w-[60px]">{transcript.time}</p>
                                        <p className="text-gray-700 leading-relaxed font-body">{transcript.message}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </TabsContent>
                </Tabs>
            </div>
        </MainSidebar>
    )
}